<template>
  <span :class="_class">
    <span
      v-tooltip="tooltip ? tooltip : false"
      :class="profileUrl ? 'avatar-symbol profile-img' : 'avatar-symbol'"
      :style="profileUrl ? 'background-image: url(' + profileUrl + ');' : null"
      :role="profileUrl ? 'img' : 'presentation'"
      :aria-label="
        profileUrl
          ? profileLabel
            ? profileLabel
            : resolveTxt('skin.avatar.profile', 'Profile')
          : null
      "
    >
      <slot name="icon"
        ><span
          v-if="!profileUrl"
          class="icon icon-user-option"
          role="img"
          :aria-label="
            profileLabel
              ? profileLabel
              : resolveTxt('skin.avatar.profile', 'Profile')
          "
        ></span
      ></slot>
    </span>
    <span v-if="$slots.default" class="avatar-body">
      <slot></slot>
    </span>
  </span>
</template>
<script lang="ts">
import { Component, Vue, Prop, Inject } from "vue-facing-decorator";
import { PropOptions } from "vue";

@Component({ name: "cat-avatar" })
export default class CatAvatar extends Vue {
  @Prop({
    type: String,
    default: "",
    description: "Other variations: 'small', 'large', 'xl'"
  } as PropOptions<any>)
  readonly size?: string;
  @Prop({
    type: String,
    default: "circle",
    description: "Always circle"
  } as PropOptions<any>)
  readonly appearance?: string;
  @Prop({
    default: "middle",
    type: String,
    description: "one of: top, bottom, middle"
  } as PropOptions<any>)
  readonly align?: string;
  @Prop({
    type: String,
    description:
      "Use the tooltip provide additional description if there's no text describing the avatar"
  } as PropOptions<any>)
  readonly tooltip?: string;
  @Prop({
    type: String,
    default: null,
    description: "URL of the profile image (WIP)"
  } as PropOptions<any>)
  readonly profileUrl?: string; //Future ?
  @Prop({
    type: String,
    description: "Accessible name for the profile image"
  } as PropOptions<any>)
  readonly profileLabel?: string;

  @Inject({ from: "resolveTxt", default: false })
  readonly resolveTxt!: Function;

  get _class(): object {
    return {
      "cat-avatar": true,
      [this.size as string]: true,
      [this.appearance as string]: true,
      [("flex-align-" + this.align) as string]: true
    };
  }
}
</script>
